module.exports = __webpack_public_path__ + "img/step-bg.4050f2a5.png";